module.exports = __webpack_public_path__ + "static/media/utensil-fork.d569d68f.svg";